import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import HomeownerAccountProperty from 'models/homeownerAccounts/HomeownerAccountProperty';
import { BASE_PATHS } from 'routes/paths';
import { fetchAccountProperties } from 'store/redux/homeowner-accounts/actions';

export function useProperties(enabled = true) {
  const dispatch = useDispatch();
  const history = useHistory();
  // The state holds the mapped list built below, not an opaque value; `unknown`
  // forced every consumer to cast it back.
  const [properties, setProperties] = useState<
    HomeownerAccountProperty[] | undefined
  >();
  const [loading, setLoading] = useState(false);

  const fetchProperties = useCallback(async () => {
    setLoading(true);
    // The promise middleware resolves `dispatch` to the API response, which the
    // `Dispatch` type models as the action object it was handed. `any` also covers
    // this variable being reassigned below from the response to the mapped list.
    let propertiesResponse: any = await dispatch(fetchAccountProperties());

    if (!propertiesResponse?.properties?.length) {
      history.push(BASE_PATHS.ACCOUNTS);
    }

    propertiesResponse = propertiesResponse.properties?.map(
      (property: any) => new HomeownerAccountProperty(property),
    );
    setProperties(propertiesResponse);
    setLoading(false);

    return propertiesResponse;
  }, [dispatch, history]);

  useEffect(() => {
    if (enabled) {
      fetchProperties();
    }
  }, [fetchProperties, enabled]);

  return { properties, fetchProperties, isLoadingProperties: loading };
}
